(function () {
  /* Open drawer on add (existing behaviour) */
  function patchTheme() {
    var CD = customElements.get('cart-drawer');
    if (!CD || !CD.prototype._onCartChanged || CD.prototype._onCartChanged.__fast) return !!CD;
    var orig = CD.prototype._onCartChanged;
    CD.prototype._onCartChanged = function (event) {
      if (event && event.detail) event.detail.baseEvent = 'variant:add';
      return orig.call(this, event);
    };
    CD.prototype._onCartChanged.__fast = true;
    return true;
  }
  if (!patchTheme()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (patchTheme() || ++tries > 40) clearInterval(timer);
    }, 50);
  }
})();

(function () {
  /* Keep quantity-selector buttons firing change (theme expects it) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#cart-drawer .quantity-selector__button');
    if (!btn) return;
    var input = btn.closest('quantity-selector') && btn.closest('quantity-selector').querySelector('input');
    if (!input) return;
    setTimeout(function () { input.dispatchEvent(new Event('change', { bubbles: true })); }, 0);
  }, true);
})();

(function () {
  /* Fast qty / remove: optimistic UI + skip extra cart.js when possible + coalesce rapid clicks */
  var pending = Object.create(null);
  var timers = Object.create(null);

  function optimisticQty(lineKey, qty) {
    document.querySelectorAll('[data-line-key="' + lineKey + '"]').forEach(function (el) {
      if (el.matches('input, [is="quantity-input"]')) el.value = String(Math.max(0, qty));
      var line = el.closest('line-item');
      if (!line) return;
      if (qty <= 0) {
        line.style.opacity = '0.35';
        line.style.pointerEvents = 'none';
        line.setAttribute('data-bl-removing', '1');
      } else {
        line.style.opacity = '';
        line.style.pointerEvents = '';
        line.removeAttribute('data-bl-removing');
      }
    });
    var countEls = document.querySelectorAll('cart-count, [data-cart-count]');
    /* count updated after server; skip guessing */
  }

  function patchLineQty() {
    var LIQ = customElements.get('line-item-quantity');
    if (!LIQ || LIQ.prototype.__blFastQty) return !!LIQ;
    var orig = LIQ.prototype._changeLineItemQuantity;

    LIQ.prototype._changeLineItemQuantity = function (lineKey, targetQuantity) {
      var self = this;
      optimisticQty(lineKey, targetQuantity);
      pending[lineKey] = targetQuantity;
      clearTimeout(timers[lineKey]);
      timers[lineKey] = setTimeout(function () {
        var qty = pending[lineKey];
        delete pending[lineKey];
        delete timers[lineKey];
        runChange(self, lineKey, qty, orig);
      }, 90);
    };
    LIQ.prototype.__blFastQty = true;
    return true;
  }

  async function runChange(self, lineKey, targetQuantity, orig) {
    var lineItem = self.closest('line-item');
    try {
      lineItem && lineItem.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: targetQuantity } }));
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      var res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: targetQuantity, sections: sectionsToBundle })
      });
      var cartContent = await res.json();
      if (!res.ok) throw cartContent;

      var quantityAfterChange = targetQuantity > 0 ? targetQuantity : 0;
      if (Array.isArray(cartContent.items)) {
        var found = cartContent.items.filter(function (it) { return it.key === lineKey; });
        quantityAfterChange = found.length === 0 ? 0 : found[0].quantity;
      }
      lineItem && lineItem.dispatchEvent(new CustomEvent('line-item:change', {
        bubbles: true,
        detail: { quantity: quantityAfterChange, cart: cartContent }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart: cartContent }
      }));
    } catch (err) {
      /* Fallback to theme resolver (handles stale keys / gift apps) */
      return orig.call(self, lineKey, targetQuantity);
    }
  }

  if (!patchLineQty()) {
    var n = 0;
    var t = setInterval(function () {
      if (patchLineQty() || ++n > 40) clearInterval(t);
    }, 50);
  }
})();

(function () {
  /* Same colour+size already in bag → only open drawer.
     Detect product forms broadly (is=, instanceof, /cart/add, buy-buttons). */
  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      try { drawer.show(); } catch (e) {}
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  function isProductAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.__blIgnoreSame) return false;
    if (form.getAttribute('is') === 'product-form') return true;
    try {
      var PF = customElements.get('product-form');
      if (PF && form instanceof PF) return true;
    } catch (e) {}
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') !== -1 && form.querySelector('[name="id"]')) return true;
    if (form.closest('buy-buttons') && form.querySelector('[name="id"]')) return true;
    return false;
  }
  function variantIdFrom(form) {
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    try {
      if (form.id && form.id.value) return form.id.value;
    } catch (e) {}
    var named = form.elements && form.elements.namedItem && form.elements.namedItem('id');
    if (named) {
      if (named.length && named[0]) return named[0].value;
      return named.value;
    }
    return '';
  }

  async function handleProductSubmit(form, event) {
    if (form.__blSameCheck) return false;
    var variantId = variantIdFrom(form);
    if (!variantId) return false;

    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    form.__blSameCheck = true;

    var submitButtons = Array.from(form.elements).filter(function (b) { return b.type === 'submit'; });
    submitButtons.forEach(function (b) {
      b.setAttribute('disabled', 'disabled');
      b.setAttribute('aria-busy', 'true');
    });

    try {
      var cart = await (await fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var exists = (cart.items || []).some(function (it) {
        return String(it.variant_id) === String(variantId);
      });
      if (exists) {
        openDrawer();
        return true;
      }

      // Not in cart — run theme add logic without re-entering our guard
      form.__blIgnoreSame = true;
      var PF = customElements.get('product-form');
      if (PF && PF.prototype && typeof PF.prototype._onSubmit === 'function') {
        await PF.prototype._onSubmit.call(form, { preventDefault: function () {}, stopPropagation: function () {} });
      } else {
        var fd = new FormData(form);
        var sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        fd.set('sections', sectionsToBundle.join(','));
        var res = await fetch(rootPath() + 'cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        var responseJson = await res.json();
        if (res.ok) {
          var cartContent = await (await fetch(rootPath() + 'cart.js')).json();
          cartContent.sections = responseJson.sections;
          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: responseJson.items || [responseJson], cart: cartContent }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          }));
          openDrawer();
        }
      }
      return true;
    } catch (err) {
      return false;
    } finally {
      form.__blSameCheck = false;
      form.__blIgnoreSame = false;
      submitButtons.forEach(function (b) {
        b.removeAttribute('disabled');
        b.removeAttribute('aria-busy');
      });
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isProductAddForm(form)) return;
    handleProductSubmit(form, e);
  }, true);

  /* Also patch ProductForm when defined (belt and suspenders) */
  function patchPF() {
    var PF = customElements.get('product-form');
    if (!PF || PF.prototype.__blSamePatched) return !!PF;
    var orig = PF.prototype._onSubmit;
    PF.prototype._onSubmit = async function (event) {
      if (this.__blIgnoreSame) return orig.call(this, event);
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      var variantId = variantIdFrom(this);
      if (variantId) {
        try {
          var cart = await (await fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          if ((cart.items || []).some(function (it) { return String(it.variant_id) === String(variantId); })) {
            openDrawer();
            return;
          }
        } catch (e) {}
      }
      return orig.call(this, event);
    };
    PF.prototype.__blSamePatched = true;
    return true;
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-form').then(patchPF);
  }
  if (!patchPF()) {
    var n = 0;
    var tmr = setInterval(function () {
      if (patchPF() || ++n > 80) clearInterval(tmr);
    }, 50);
  }
})();


(function () {
  function syncEmpty(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !cart) return;
    var empty = !cart.item_count;
    drawer.setAttribute('data-empty', empty ? 'true' : 'false');
    drawer.querySelectorAll('[name="checkout"], .buy-buttons .button').forEach(function (btn) {
      if (empty) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('disabled');
      }
    });
  }
  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart) syncEmpty(e.detail.cart);
  });
  document.addEventListener('variant:add', function (e) {
    if (e.detail && e.detail.cart) syncEmpty(e.detail.cart);
  });
})();
